import { render, staticRenderFns } from "./FbIcon.vue?vue&type=template&id=748109c3&functional=true&"
import script from "./FbIcon.vue?vue&type=script&lang=js&"
export * from "./FbIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports